(function () {
  function loadDeferredSliderImages(wrapper) {
    if (!wrapper) return;
    if (wrapper.dataset.falashSliderImagesLoaded === 'true') return;

    wrapper.dataset.falashSliderImagesLoaded = 'true';

    var deferredResponsiveImages = wrapper.querySelectorAll('[data-falash-slider-src]');

    deferredResponsiveImages.forEach(function (img) {
      var src = img.getAttribute('data-falash-slider-src');
      var srcset = img.getAttribute('data-falash-slider-srcset');
      var sizes = img.getAttribute('data-falash-slider-sizes');

      if (!src) return;

      img.onload = function () {
        img.classList.add('is-loaded');
      };

      if (sizes) {
        img.setAttribute('sizes', sizes);
      }

      if (srcset) {
        img.setAttribute('srcset', srcset);
      }

      img.setAttribute('src', src);
    });

    var deferredBackgroundImages = wrapper.querySelectorAll('[data-falash-slider-bg]');

    deferredBackgroundImages.forEach(function (el) {
      var bgSrc = el.getAttribute('data-falash-slider-bg');
      if (!bgSrc) return;

      var bgImg = new Image();

      bgImg.onload = function () {
        el.style.backgroundImage = 'url("' + bgSrc + '")';
        el.classList.add('is-loaded');
      };

      bgImg.src = bgSrc;
    });
  }

  function updateProductCardSliderProgress(slider) {
    if (!slider) return;

    var wrapper = slider.closest('.product-item__thumbnail--slider');
    if (!wrapper) return;

    var items = wrapper.querySelectorAll('[data-slider-progress-item]');
    if (!items.length) return;

    var activeIndex = Math.round(slider.scrollLeft / slider.clientWidth);

    if (activeIndex < 0) activeIndex = 0;
    if (activeIndex > items.length - 1) activeIndex = items.length - 1;

    items.forEach(function (item, index) {
      item.classList.toggle('product-card-slider__progress-item--active', index === activeIndex);
    });
  }

  function resetProductCardSlider(slider) {
    if (!slider) return;

    slider.scrollLeft = 0;
    updateProductCardSliderProgress(slider);
  }

  function initProductCardSliders(context) {
    var root = context || document;

    root.querySelectorAll('[data-product-card-slider]').forEach(function (slider) {
      if (slider.dataset.falashSliderReady === 'true') return;

      slider.dataset.falashSliderReady = 'true';

      resetProductCardSlider(slider);

      setTimeout(function () {
        resetProductCardSlider(slider);
      }, 80);

      setTimeout(function () {
        resetProductCardSlider(slider);
      }, 400);

      slider.addEventListener('scroll', function () {
        updateProductCardSliderProgress(slider);
      }, { passive: true });
    });

    root.querySelectorAll('.product-item--image-slider').forEach(function (item) {
      if (item.dataset.falashQuickBuyPositionReady === 'true') return;

      item.dataset.falashQuickBuyPositionReady = 'true';

      var image = item.querySelector('.product-item__thumbnail--slider');
      var card = item.querySelector('.product-item__variants-card');

      if (!image || !card) return;

      function positionQuickBuyCard() {
        var itemRect = item.getBoundingClientRect();
        var imageRect = image.getBoundingClientRect();

        var distanceFromItemBottomToImageBottom = itemRect.bottom - imageRect.bottom;

        card.style.bottom = distanceFromItemBottomToImageBottom + 'px';
      }

      positionQuickBuyCard();

      window.addEventListener('resize', positionQuickBuyCard);
    });
  }

  if (!window.falashProductCardSliderGlobalLoaded) {
    window.falashProductCardSliderGlobalLoaded = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-slider-next], [data-slider-prev]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      var wrapper = button.closest('.product-item__thumbnail--slider');
      if (!wrapper) return;

      loadDeferredSliderImages(wrapper);

      var slider = wrapper.querySelector('[data-product-card-slider]');
      if (!slider) return;

      var direction = button.hasAttribute('data-slider-next') ? 1 : -1;

      slider.scrollBy({
        left: slider.clientWidth * direction,
        behavior: 'smooth'
      });

      setTimeout(function () {
        updateProductCardSliderProgress(slider);
      }, 250);
    }, true);

    document.addEventListener('mouseenter', function (event) {
      var wrapper = event.target.closest && event.target.closest('.product-item__thumbnail--slider');
      if (!wrapper) return;

      loadDeferredSliderImages(wrapper);
    }, true);

    document.addEventListener('touchstart', function (event) {
      var wrapper = event.target.closest && event.target.closest('.product-item__thumbnail--slider');
      if (!wrapper) return;

      loadDeferredSliderImages(wrapper);
    }, { passive: true, capture: true });

    document.addEventListener('focusin', function (event) {
      var wrapper = event.target.closest && event.target.closest('.product-item__thumbnail--slider');
      if (!wrapper) return;

      loadDeferredSliderImages(wrapper);
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.falash-quick-buy-trigger');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var currentItem = trigger.closest('.product-item--image-slider');
      if (!currentItem) return;

      var wasActive = currentItem.classList.contains('active-quick-buy');

      document.querySelectorAll('.product-item--image-slider.active-quick-buy').forEach(function (item) {
        item.classList.remove('active-quick-buy');
      });

      if (!wasActive) {
        currentItem.classList.add('active-quick-buy');
      }
    }, true);
  }

  function runFalashProductCardSliderInit(context) {
    initProductCardSliders(context);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runFalashProductCardSliderInit(document);
    });
  } else {
    runFalashProductCardSliderInit(document);
  }

  window.addEventListener('load', function () {
    runFalashProductCardSliderInit(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    runFalashProductCardSliderInit(event.target);
  });
})();